import React from 'react'
import { DialogTitle, Dialog, Button, Box, TextField, Typography } from "@mui/material/";
import { makeStyles } from "@mui/styles";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import StaticDateRangePicker from "@mui/lab/StaticDateRangePicker";
import { DateRange } from "@mui/lab/DateRangePicker";

const useStyles = makeStyles({
    gridContainer: {
        background: "#FFFFFF",
        borderRadius: "24px",
    },
    dialog: {
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    buttontext: {
        fontFamily: "sans-serif",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "small",
    },
    dialogbox: {
        borderRadius: "20",
        borderStyle: "solid",
    },
});

/**
 * @deprecated Use CalendarModalV2 instead.
 * @param props 
 * @returns 
 */
const CalendarModal = (props: any) => {
    const classes = useStyles();
    const defaultStartDate = new Date();
    const defaultEndDate = new Date();
    const calendarWidgetDateRange: DateRange<Date> = [
        defaultStartDate,
        defaultEndDate,
    ];

    const [value, setValue] = React.useState<DateRange<Date>>(calendarWidgetDateRange);

    return (
        <Dialog onClose={props.handleClose} open={props.open} maxWidth="md" className={classes.dialogbox}
            PaperProps={{ style: { pointerEvents: "auto", borderRadius: "24px" } }}>
            <DialogTitle id="subTitle">Set Start and End Dates</DialogTitle>
            <div className={classes.dialog}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <StaticDateRangePicker
                        displayStaticWrapperAs="desktop"
                        value={value}
                        onChange={(newValue) => {
                            setValue(newValue);
                        }}
                        renderInput={(startProps, endProps) => (
                            <React.Fragment>
                                <TextField {...startProps} />
                                <Box sx={{ mx: 2 }}> to </Box>
                                <TextField {...endProps} />
                            </React.Fragment>
                        )}
                    />
                </LocalizationProvider>
            </div>
            <Box sx={{ display: "flex", p: 2, justifyContent: "center" }}>
                <Button variant="contained" onClick={() => props.handleCalendarSubmit(value)} sx={{ borderRadius: "20px", fontSize: "small" }} size="large">
                    <Typography className={classes.buttontext} variant="caption">
                        continue
                    </Typography>
                </Button>
            </Box>
        </Dialog>
    )
}
export default CalendarModal;
